import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { SxProps } from "@mui/material";

export type DropdownOptions = {
  label: string;
  value: string;
};

type DropdownProps = {
  val: string | null;
  setVal: Function;
  options: DropdownOptions[];
  label: string;
  width?: string;
  sx?: SxProps;
  maxWidthOption?: string;
  minWidthOption?: string;
  placeholder?: string;
  fullWidth?: boolean;
  [key: string]: any;
  handleCustomClick?: Function;
};

const Dropdown = (props: DropdownProps) => {
  const {
    val,
    setVal,
    options,
    label,
    width,
    maxWidthOption,
    minWidthOption,
    placeholder,
    required,
    fullWidth = false,
    handleCustomClick,
    ...restProps

  } = props;
  const handleChange = (event: SelectChangeEvent) => {
    setVal(event.target.value as string);
  };

  return (
    <FormControl
      sx={{ m: 1, minWidth: width ?? "120px", maxWidth: width }}
      size="small"
      fullWidth={fullWidth}
    >
      {val ? (
        <InputLabel id="demo-simple-select-label" required={required}>
          {label}
        </InputLabel>
      ) : (
        ""
      )}
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        fullWidth
        key={val}
        value={val ?? ""}
        label={val ? label : ""}
        onChange={handleChange}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 400,
              overflowY: "auto",
            },
          },
        }}
        {...restProps}
        displayEmpty
        renderValue={(value) => {
          const selectedOption = options.find(
            (option) => option.value.toString() === value.toString()
          );
          return selectedOption ? (
            selectedOption.label
          ) : (
            <em style={{ color: "rgba(0, 0, 0, 0.38)" }}>{placeholder}</em>
          );
        }}
      >
        {options.map((option: DropdownOptions) => {
          return (
            <MenuItem
              key={option.value}
              value={option.value}
              style={{
                minWidth: minWidthOption ?? "200px",
                maxWidth: maxWidthOption,
              }}
              onClick={() => handleCustomClick && handleCustomClick(option.value)}
            >
              {option?.label?.length > 40
                ? `${option?.label?.substring(0, 40)}...`
                : option?.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
